export default __webpack_public_path__ + "static/media/logo-with-name.8323a5fc.png";